import { Component, Input } from '@angular/core';
import { ApiFlowSection } from 'src/app/model/section/api-flow-section';

@Component({
  selector: 'app-affected-api-flow-section',
  templateUrl: './affected-api-flow-section.component.html',
  styleUrls: ['./affected-api-flow-section.component.scss']
})
export class AffectedApiFlowSectionComponent {
  @Input() sections: ApiFlowSection[] = [];
  @Input() isFareBandNameAndCodeOrderReshopPage: boolean = false;
  @Input() isAPIFlow: boolean = false;
  constructor() {}

  ngOnInit() {}
}
